import { Fragment} from 'react'
import Button from 'react-bootstrap/Button'
import EditModal from './EditModal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faEdit } from '@fortawesome/free-solid-svg-icons'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'

export default props => {

  const { id, className, mode, size, variant='primary' } = props

  const authorised = useSelector(state => {
    const { user } = state
    return  (user && user.platform && user.platform.support) || (user && user.administrator && user.administrator.entities && Array.isArray(user.administrator.entities) && user.administrator.entities.includes(id))
  })

  const history = useHistory()

  if(!authorised){
    return null
  }

  const label =id === 'new' ? 'Add an organisation' : 'Edit'
  const icon =id === 'new' ? faPlus : faEdit

  const  handleClick = (e) => {
    history.push('/entities/' + id + '/edit')
  }

  if(mode === 'icon'){
    return (
      <Fragment>
        <button title={label} onClick={handleClick} className={className}>
          <FontAwesomeIcon icon={icon} />
        </button>
        <EditModal
          id={id}
          />
      </Fragment>
    )
  }

  return (
    <Fragment>
      <Button variant={variant} title={label} onClick={handleClick} className={className} size={size}>
        <FontAwesomeIcon icon={icon} className="d-inline d-md-none" /><span className="d-none d-md-inline text-nowrap">{label}</span>
      </Button>
      <EditModal
        id={id}
        />
    </Fragment>
  )
}